export function getHeaderFileSend(state = 'Enviar arquivos', action) {
  if (action.type === 'GET_HEADER_FILE_SEND') {
    return action.nameFormSend;
  }
  return state;
}
